var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGraphIcon = function SvgGraphIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "graph-icon_svg__svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.333 170.667H312.89v768H85.333zm312.89 142.222h227.555v625.778H398.222zM711.11 426.667h227.556v512H711.11z"
  })));
};

export default SvgGraphIcon;